import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorMutationKeys } from '../../../keys'
import { UpdateGroupRequest, UpdateGroupResponse } from '../../../type'
import { updateGroup } from '../../services'

interface UpdateGroupParams {
	id: string
	payload: UpdateGroupRequest
}

export default function useMutationUpdateGroup(
	props?: UseBaseMutationOptions<UpdateGroupResponse, UpdateGroupParams>,
) {
	return useMutation({
		mutationKey: [OperatorMutationKeys.UpdateGroup],
		mutationFn: (params) => updateGroup(params.payload, params.id),
		...props,
	})
}
